<app-breadcrumb></app-breadcrumb>
<div class="card">
    <div class="card-body">
        <dtg-report-car-trip-detail-list
            [listType]="DtgListType.list"
            [dtgUnitId]="dtgUnitId"
            [fvmsTripCnt]="fvmsTripCnt"></dtg-report-car-trip-detail-list>
    </div>
</div>